<template>
	<div class="cm-detail-pricing" id="car-detail-pricing">
		<ul class="nav nav-pricing nav-justified">
			<li class="nav-item">
				<a
					@click.prevent="setPriceView('finance')"
					:class="
						this.$store.state.price.view === 'finance'
							? 'active text-finance'
							: ''
					"
					class="nav-link"
					href="#"
					>Finanzieren</a
				>
			</li>
			<li class="nav-item">
				<a
					@click.prevent="setPriceView('fixed')"
					:class="this.$store.state.price.view === 'fixed' ? 'active' : ''"
					class="nav-link"
					href="#"
					>Kaufen</a
				>
			</li>
			<li class="nav-item">
				<a
					class="nav-link"
					@click.prevent="setPriceView('leasing')"
					:class="{
						disabled: !car.leasing,
						'active text-secondary': this.$store.state.price.view === 'leasing',
					}"
					href="#"
					>Leasing</a
				>
			</li>
		</ul>
		<div class="price mb-2">
			<template v-if="this.$store.state.price.view === 'finance'">
				<div class="price-body" v-if="finance.selected">
					<div class="row g-3 align-items-center">
						<div class="col-auto me-auto">
							<span class="lbl">Finanzierungsrate mtl.</span>
							<div class="sub-lbl">
								<a
									class="dropdown-toggle link-finance dropdown-details d-inline-block link-details no-caret"
									href="#"
									data-bs-toggle="dropdown"
									data-bs-auto-close="outside"
									aria-expanded="false"
									><i class="show-icon mdi mdi-information-outline me-1"></i
									><i class="close-icon mdi mdi-close-thick me-1"></i>Details
									zur Finanzierung
								</a>
								<div
									style="min-width: 210px; max-width: 340px"
									id="dropdown-price-finance"
									class="dropdown-menu dropdown-shadow p-0"
									aria-labelledby="dropdownMenuClickableInside"
								>
									<dropdown-price-financing
										:car="car"
										:finance="finance.selected"
									/>
								</div>
							</div>
						</div>
						<div class="col-auto text-end">
							<h3
								class="rate text-finance"
								:style="priceFinancingRateLoaded ? '' : 'opacity: 0.3;'"
							>
								{{ getPrice(this.$store.state.price.financing.rate)
								}}<small>€</small>
							</h3>
						</div>
					</div>
				</div>
				<div class="price-body" v-else>
					<div class="row g-3 align-items-center">
						<div class="col-auto me-auto">
							<span class="lbl">Finanzierungsrate mtl.</span>
						</div>
						<div class="col-auto text-end">
							<h4 class="rate text-finance pt-2">Anfragen</h4>
						</div>
					</div>
				</div>
				<div class="price-body py-3">
					<div class="row gx-1 align-items-center mb-3">
						<label class="col-lg-4 col-form-label">Laufzeit (Monat)</label>
						<div class="col-lg-8">
							<div
								class="btn-group d-flex flex-fill w-100"
								role="group"
								aria-label="Basic radio toggle button group"
							>
								<template v-for="period in finance.rangePeriod" :key="period">
									<button
										@click="setFinancingPeriod(period)"
										type="button"
										class="btn px-2"
										:class="
											this.$store.state.price.financing.period === period
												? 'btn-dark'
												: 'btn-white'
										"
									>
										{{ period }}
									</button>
								</template>
							</div>
						</div>
					</div>
					<div class="row gx-1 align-items-center">
						<label class="col-lg-4 col-form-label">Anzahlung</label>
						<div class="col-lg-8">
							<div class="input-group">
								<span class="input-group-text bg-white">€</span>
								<input
									v-model="this.$store.state.price.financing.deposit"
									type="number"
									class="form-control"
									placeholder="0"
									@change="getFinance()"
								/>
								<button
									type="button"
									class="btn btn-white"
									@click="getFinance()"
								>
									<span class="mdi mdi-reload"></span>
								</button>
							</div>
						</div>
					</div>
				</div>
			</template>
			<template v-else-if="this.$store.state.price.view === 'leasing'">
				<div class="price-body" v-if="car.leasing">
					<div class="row gx-3 align-items-center">
						<div class="col-auto me-auto">
							<span class="lbl">Leasingrate mtl.</span>
							<div class="sub-lbl">
								<a
									class="dropdown-toggle dropdown-details link-secondary d-inline-block link-details no-caret"
									href="#dropdown-price-leasing"
									data-bs-toggle="dropdown"
									data-bs-auto-close="outside"
									aria-expanded="false"
									><i
										class="show-icon mdi mdi-information-outline text-secondary me-1"
									></i
									><i
										class="close-icon mdi mdi-close-thick text-secondary me-1"
									></i
									>Leasingdetails
								</a>
								<div
									style="min-width: 210px; max-width: 340px"
									id="dropdown-price-leasing"
									class="dropdown-menu dropdown-shadow p-0"
								>
									<dropdown-price-leasing
										:car="car"
										:leasing="leasing.selected"
									/>
								</div>
							</div>
						</div>
						<div class="col-auto text-end">
							<h3 class="rate text-secondary">
								{{ getPrice(leasing.selected.grossRate) }}<small>€</small>
							</h3>
						</div>
					</div>
					<hr />
					<p class="font-12 text-muted pt-0 mb-1">
						Dieses Angebot erfordert eine Sonderzahlung in Höhe von
						{{ getPrice(leasing.selected.downPayment) }} €.
					</p>
				</div>
				<div class="price-body" v-else>
					<div class="row gx-3 align-items-center">
						<div class="col-auto me-auto">
							<span class="lbl">Leasingrate mtl.</span>
						</div>
						<div class="col-auto text-end">
							<h3 class="rate text-secondary">Anfrage</h3>
						</div>
					</div>
				</div>
				<div class="price-body py-3">
					<div class="row gx-1 align-items-center mb-lg-3 mb-1">
						<label class="col-lg-4 col-form-label">Laufzeit (Monat)</label>
						<div class="col-lg-8">
							<div
								class="btn-group d-flex flex-fill w-100"
								role="group"
								aria-label="Basic radio toggle button group"
							>
								<template v-for="period in leasing.rangePeriod" :key="period">
									<button
										@click="setLeasingPeriod(period)"
										type="button"
										class="btn px-2"
										:class="
											this.$store.state.price.leasing.period === period
												? 'btn-dark'
												: 'btn-white'
										"
									>
										{{ period }}
									</button>
								</template>
							</div>
						</div>
					</div>
					<div class="row gx-1 align-items-center">
						<label class="col-lg-4 col-form-label">Kilometer (Jahr)</label>
						<div class="col-lg-8">
							<div
								class="btn-group d-flex flex-fill w-100"
								role="group"
								aria-label="Basic radio toggle button group"
							>
								<template v-for="milage in leasing.rangeMileage" :key="milage">
									<button
										@click="setLeasingMileage(milage)"
										type="button"
										class="btn px-2"
										:class="
											this.$store.state.price.leasing.mileage === milage
												? 'btn-dark'
												: 'btn-white'
										"
									>
										{{ getPrice(milage) }}
									</button>
								</template>
							</div>
						</div>
					</div>
				</div>
			</template>
			<template v-else>
				<div class="price-body">
					<div class="row g-3 align-items-center">
						<div class="col-auto me-auto">
							<span class="lbl"
								>Verkaufspreis<sup>{{ getTaxNumber(car) }}</sup></span
							>
							<span class="sub-lbl">{{ getTaxText(car) }}</span>
						</div>
						<div class="col-auto text-end">
							<h3 class="">
								{{ getPrice(car.consumerPriceGross) }}<small>€</small>
							</h3>
						</div>
					</div>
					<template v-if="car.dealerPriceGross > 0">
						<hr />
						<div class="row g-3 align-items-center">
							<div class="col-auto me-auto">
								<span class="lbl">UPE<sup>3</sup></span>
							</div>
							<div class="col-auto text-end d-none">
								<p class="text-danger font-w-600 mb-0">
									Preisvorteil
									{{ getPrice(car.discountPriceGross) }}
									€
								</p>
							</div>
							<div class="col-auto text-end">
								<h3 class="upe">
									{{ getPrice(car.dealerPriceGross) }}<small>€</small>
								</h3>
							</div>
						</div>
					</template>
				</div>
			</template>
			<div class="price-body py-3">
				<div class="row g-2">
					<div class="col-md-6">
						<button
							type="button"
							@click="scrollTo('card-contact', -60)"
							class="btn btn-block btn-dark text-nowrap"
						>
							Jetzt anfragen <i class="mdi mdi-send"></i>
						</button>
					</div>
					<div class="col-md-6">
						<a
							v-if="whatsappOnline()"
							class="btn btn-block btn-whatsapp btn-whatsapp-carmarket-lead"
							target="_blank"
							:href="getWhatsAppLink(car, this.$store.state.price, title)"
						>
							<i class="mdi mdi-whatsapp"></i> WhatsApp
						</a>
						<button
							v-else
							class="btn btn-block btn-light"
							type="button"
							disabled
						>
							<i class="mdi mdi-whatsapp"></i> WhatsApp
							<small class="text-danger font-12 font-w-500">Offline</small>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import store from '@/store'
import DarmasApiService from '@/services/DarmasApiService'
import DropdownPriceFinancing from '@/components/details/DetailsDropdownPriceFinancing'
import DropdownPriceLeasing from '@/components/details/DetailsDropdownPriceLeasing'

export default {
	name: 'DetailsPricing',
	components: {
		DropdownPriceFinancing,
		DropdownPriceLeasing,
	},
	data() {
		return {
			priceView: 'fixed',
			priceFinancingRateLoaded: false,
			finance: {
				selected: {
					annualPercentageRate: 0,
					nominalInterestRate: 0,
					firstInstallment: 0,
					monthlyInstallment: 0,
					finalInstallment: 0,
					paybackPeriod: 36,
					netLoanAmount: 0,
					grossLoanAmount: 0,
					closingCosts: 0,
					paymentProtectionInsurance: 0,
					bank: '',
				},
				percentage: 4.99,
				rangePeriod: [36, 48, 60],
			},
			leasing: {
				selected: null,
				rangePeriod: [24, 36, 48],
				rangeMileage: [10000, 15000, 20000],
			},
		}
	},
	props: {
		car: {
			type: Object,
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
	},
	methods: {
		setLeasingPeriod(period) {
			store.state.price.leasing.period = period
			this.getLeasing()
		},
		setLeasingMileage(mileage) {
			store.state.price.leasing.mileage = mileage
			this.getLeasing()
		},
		setFinancingPeriod(period) {
			store.state.price.financing.period = period
			this.getFinance()
		},
		getLeasing() {
			const mileage = store.state.price.leasing.mileage
			const period = store.state.price.leasing.period
			const selectedRate = this.car.darmasDeLeasing.rates.filter((rate) => {
				return rate.termOfContract == period && rate.annualMileage == mileage
			})
			this.leasing.selected =
				selectedRate.length > 0 ? selectedRate[0] : this.car.leasing

			store.state.price.leasing.rate = +this.leasing.selected.grossRate
		},
		getFinance() {
			const priceUpe = this.car.dealerPriceGross
			const priceVk = this.car.consumerPriceGross
			const priceDeliveryCosts = 890
			let priceCar

			if (
				(this.car.ad.condition === 'NEW' ||
					this.car.ad.useageType === 'DEMONSTRATION' ||
					this.car.ad.useageType === 'PRE_REGISTRATION') &&
				priceUpe > 0
			) {
				priceCar = priceUpe
			} else {
				priceCar = priceVk + priceDeliveryCosts
			}

			const firstInstallment = store.state.price.financing.deposit
			const period = store.state.price.financing.period

			if (firstInstallment < 0) {
				this.$toast('Die Anzahlung darf keinen negative Betrag enthalten', {
					type: 'error',
				})
				store.state.price.financing.deposit =
					this.finance.selected.firstInstallment
			} else if (firstInstallment > priceCar / 2) {
				this.$toast(
					'Die Anzahlung darf nicht höher als 50% des Kaufpreises sein',
					{
						type: 'error',
					}
				)
				store.state.price.financing.deposit =
					this.finance.selected.firstInstallment
			} else {
				this.priceFinancingRateLoaded = false
				DarmasApiService.getFinancingValue(
					this.car._id,
					firstInstallment,
					period
				)
					.then((response) => {
						if (response.data === null) {
							this.$toast(
								'Serverfehler! Bitte versuchen Sie es später noch einmal',
								{
									type: 'error',
								}
							)
						} else if (response.data.data === null) {
							this.$toast(
								'Serverfehler! Bitte versuchen Sie es später noch einmal',
								{
									type: 'error',
								}
							)
						} else {
							const financingData = response.data
							this.finance.selected = financingData
							store.state.price.financing.rate =
								financingData.monthlyInstallment
							this.priceFinancingRateLoaded = true
						}
					})
					.catch((error) => {
						console.log(error)
					})
			}
		},
		setPriceView(payment) {
			store.state.price.view = payment
			this.priceView = payment
		},
	},
	created() {
		this.priceView = store.state.price.view
		if (!this.car.leasing && store.state.price.view === 'leasing') {
			store.state.price.view = 'finance'
			this.$toast(
				'Leasing nicht möglich, es wird die Finanzierungsrate angezeigt',
				{
					type: 'info',
				}
			)
		}
		if (this.car.leasing) {
			this.leasing.selected = this.car.leasing
			store.state.price.leasing.period = Number(this.car.leasing.termOfContract)
			store.state.price.leasing.deposit = this.car.leasing.downPayment
			store.state.price.leasing.rate = +this.car.leasing.grossRate
			store.state.price.leasing.mileage = +this.car.leasing.annualMileage
			this.getLeasing()
		}
		if (this.car.finance) {
			this.finance.selected = this.car.finance
			store.state.price.financing.deposit = this.car.finance.firstInstallment
			store.state.price.financing.period = this.car.finance.paybackPeriod
			store.state.price.financing.rate = this.car.finance.monthlyInstallment
			this.priceFinancingRateLoaded = true
		}
	},
	mounted() {},
}
</script>

<style lang="scss" scoped>
.nav-pricing {
	background-color: #ededed;
	border-bottom: 1px solid #d9d9d9;
	border-top-left-radius: $border-radius-lg;
	border-top-right-radius: $border-radius-lg;
	li {
		a {
			border-top-left-radius: $border-radius-lg;
			border-top-right-radius: $border-radius-lg;
			padding: 0.55rem 1rem;
			font-weight: 500;
			font-family: $font-family-base;
			color: $dark;

			border-left: 1px solid #ededed;
			border-top: 1px solid #ededed;
			border-right: 1px solid #ededed;
			margin-bottom: -1px;
			border-bottom: 1px solid transparent;
			&:hover {
				background-color: rgba(255, 255, 255, 0.5);
			}
			&.active {
				background-color: #fff;
				font-weight: 600;
				color: $dark;
				border-bottom: 1px solid #fff;

				border-left: 1px solid #d9d9d9;
				border-top: 1px solid #d9d9d9;
				border-right: 1px solid #d9d9d9;
			}
			&.disabled {
				color: $gray-550;
				text-decoration: line-through;
			}
		}
	}
}

.lbl-light {
	color: $gray-550;
	font-size: $px14;
	line-height: $px16;
	display: inline-block;
}

.price {
	.price-body {
		padding: 0.7rem 1rem;
		border: $border;
		border-top: none;
		hr {
			border-top: 1px dotted $border-color;
			color: transparent;
			margin: 0.7rem 0;
		}
		&:last-of-type {
			border-bottom-left-radius: $border-radius-lg;
			border-bottom-right-radius: $border-radius-lg;
		}
	}
	.lbl {
		display: block;
		font-size: $px16;
		line-height: $px18;
		font-weight: 600;
		color: $gray-800;
	}
	.sub-lbl {
		font-size: $px14;
		color: $gray-600;
	}

	a.link-details {
		display: inline-block;
		font-size: $px14;
		line-height: $px16;
	}

	h3 {
		display: inline-block;
		font-family: $font-family-base;
		font-size: $px38;
		margin-bottom: 0;
		small {
			font-size: $px28;
		}
		&.upe {
			font-weight: 500;
			color: $gray-600;
			font-size: $px24;
			text-decoration: line-through;
			small {
				font-size: $px18;
			}
		}
	}
}

.cm-detail-pricing {
	.detail-price {
		padding: $px8 $px16;
		margin-bottom: 1px;

		&.price-bfvk {
			background-color: $dark;
			color: #fff;
		}
		&.price-leasing {
			background-color: $secondary;
			color: #fff;
		}
		&.price-vk {
			background-color: $green;
			color: #fff;
		}
		&.price-rabatt {
			background-color: $primary;
			color: #fff;
		}
		&.price-upe {
			background-color: $gray-200;
			color: #000;
			position: relative;
			hr {
				opacity: 0.9;
				top: 12px;
				margin: 0;
				right: 0px;
				padding: 0;
				border-top: 3px solid $red;
				position: absolute;
				width: 100%;
				transform: rotate(10deg);
			}
		}
		.detail-leasingprice {
			font-size: $px12;

			> div {
				> div {
					font-size: $px12;
				}
			}
		}
	}
}

.leasing-subtext {
	color: #c9c9c9;
}
</style>
